import { Component, OnInit, Output, Input, EventEmitter } from '@angular/core';

import { Controllers } from '@shared/core/controllers';

import { Observable } from 'rxjs';

@Component({
    selector: 'shared-auth-back',
    templateUrl: './auth-back.shared.component.html',
    styleUrls: ['./auth-back.shared.component.scss']
})
export class AuthBackComponent implements OnInit {
    @Input() public isVisible: boolean = false;
    @Output() public onClick: EventEmitter<Event> = new EventEmitter();

    public isVisible$: Observable<boolean>;
    public canNavBack$: Observable<boolean>;

    constructor(
        public controllers: Controllers,
    ) { }

    ngOnInit(): void {
        this.isVisible$ = this.controllers.members.showNavBackAuthProcess$();
        this.canNavBack$ = this.controllers.members.canNavBackAuthProcess$();
    }

    public handleClick($event: Event): void {
        this.onClick.emit($event);

        /* canNavBackAuthProcess$ */
    }
}
